var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 462.94 154.31",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: url(#linear-gradient-2);\n      }\n\n      .cls-2 {\n        clip-path: url(#clippath);\n      }\n\n      .cls-3 {\n        fill: none;\n      }\n\n      .cls-4 {\n        fill: #0b2337;\n      }\n\n      .cls-5 {\n        fill: url(#linear-gradient-3);\n      }\n\n      .cls-6 {\n        fill: url(#linear-gradient);\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    width: 462.94,
    height: 154.31
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 78.63,
    y1: 121.13,
    x2: 32.19,
    y2: 121.62,
    gradientTransform: "translate(0 156.31) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0b2337"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#0c2639"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#0f2f41"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#143f4e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#1c5661"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#25737a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2f8f91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 87.52,
    y1: -15.5,
    x2: 45.14,
    y2: 57.75,
    gradientTransform: "translate(0 156.31) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#286da9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#2870a6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#2a79a0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#2d8994"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2f8f91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 64.77,
    y1: 121.59,
    x2: 154.8,
    y2: 121.59,
    gradientTransform: "translate(0 156.31) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2f8f91"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#308f8e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#359285"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#3e9675"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#4a9c5f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#59a443"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#6cad21"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6faf1d"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m64.77,30.23l-7.96,16.77h-.91L28.28,0H0l42.17,69.45h27.33l20.54-39.22h-25.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m154.79,154.31h-35.84l-28.06-47.67h-26.98l-28.06,47.67H0l43.49-69.43h67.82l43.48,69.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m126.51,0l-27.61,47h-.93l-7.95-16.77h-25.26l20.54,39.22h27.31L154.8,0h-28.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m197.89,49.35c0-14.08,8.71-23.61,22.13-23.61,12.06,0,21.45,7.66,21.45,23.17v3.47h-31.07v.03c0,6.8,4.01,10.99,10.34,10.99,4.22,0,7.48-1.81,8.76-5.29l11.7.77c-1.79,8.46-9.39,13.97-20.68,13.97-14.06,0-22.63-9.03-22.63-23.49h0Zm31.66-4.82c-.03-5.44-3.83-9.36-9.32-9.36s-9.57,4.15-9.84,9.36h19.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m264.56,42.28l8.59-15.95h12.98l-13.22,22.81,13.58,22.81h-12.92l-9-15.78-8.85,15.78h-13.07l13.54-22.81-13.07-22.81h13.07l8.37,15.95Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m330.09,32.62c-3.41-4.6-8.38-6.88-13.81-6.88-7.63,0-11.29,4.54-12.99,8.26h-.57v-7.66h-12.47v58.75c4.62.36,8.87,1.54,12.65,3.43v-23.87h.39c1.75,3.81,5.58,8.05,12.95,8.05,5.52,0,10.38-2.31,13.73-6.75,2.98-3.95,4.77-9.57,4.77-16.74s-1.77-12.72-4.67-16.59h.01Zm-17.85,30.01c-6.1,0-9.59-5.35-9.59-13.49s3.45-13.34,9.59-13.34,9.59,5.44,9.59,13.34-3.38,13.49-9.59,13.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m337.98,49.35c0-14.08,8.71-23.61,22.13-23.61,12.06,0,21.45,7.66,21.45,23.17v3.47h-31.07v.03c0,6.8,4.01,10.99,10.34,10.99,4.22,0,7.48-1.81,8.76-5.29l11.7.77c-1.79,8.46-9.39,13.97-20.68,13.97-14.06,0-22.63-9.03-22.63-23.49h0Zm31.66-4.82c-.03-5.44-3.83-9.36-9.32-9.36s-9.57,4.15-9.84,9.36h19.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m386.46,26.34h12.27v7.96h.47c1.66-5.65,5.85-8.62,10.96-8.62,1.27,0,2.85.18,3.99.45v11.23c-1.18-.39-3.6-.68-5.35-.68-5.58,0-9.68,3.86-9.68,9.48v25.81h-12.65V26.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m443.87,35.84h-8.59v22.11c0,3.51,1.75,4.45,4.28,4.45,1.18,0,2.52-.3,3.15-.41l1.99,9.41c-1.27.41-3.59,1.07-6.87,1.18-9.18.39-15.26-4.04-15.21-12.97v-23.76h-6.24v-9.5h6.24v-10.93h12.65v10.93h8.59v9.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m196.31,92.39h12.81l7.07,30.66h.41l7.37-30.66h12.56l7.48,30.48h.39l6.96-30.48h12.77l-12.38,45.62h-13.4l-7.84-28.69h-.57l-7.84,28.69h-13.36l-12.42-45.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m264.53,115.39c0-14.15,8.62-23.58,22.45-23.58s22.45,9.45,22.45,23.58-8.62,23.53-22.45,23.53-22.45-9.48-22.45-23.53Zm32.06-.09c0-7.96-3.27-13.84-9.54-13.84s-9.66,5.88-9.66,13.84,3.27,13.81,9.66,13.81,9.54-5.85,9.54-13.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m314.35,92.39h12.27v7.96h.48c1.66-5.65,5.85-8.62,10.96-8.62,1.27,0,2.85.18,3.99.45v11.23c-1.18-.39-3.6-.68-5.35-.68-5.58,0-9.68,3.86-9.68,9.48v25.81h-12.65v-45.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m370.73,112.15l16.92-19.75h-14.53l-14.61,17.32h-.68v-30.1c-4.63-.28-8.89-1.34-12.65-3.05v61.47h12.65v-14.51l3.42-3.88,12.45,18.39h14.83l-17.8-25.87h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m386.76,115.41c0-14.08,8.71-23.61,22.13-23.61,12.06,0,21.45,7.66,21.45,23.17v3.47h-31.07v.03c0,6.8,4.01,10.99,10.34,10.99,4.22,0,7.48-1.81,8.76-5.29l11.7.77c-1.79,8.46-9.39,13.97-20.68,13.97-14.05,0-22.63-9.03-22.63-23.49h0Zm31.66-4.82c-.03-5.44-3.83-9.36-9.32-9.36s-9.57,4.15-9.84,9.36h19.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m435.25,92.39h12.27v7.96h.48c1.66-5.65,5.85-8.62,10.96-8.62,1.27,0,2.85.18,3.99.45v11.23c-1.18-.39-3.6-.68-5.35-.68-5.58,0-9.68,3.86-9.68,9.48v25.81h-12.65v-45.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m197.89,49.35c0-14.08,8.71-23.61,22.13-23.61,12.06,0,21.45,7.66,21.45,23.17v3.47h-31.07v.03c0,6.8,4.01,10.99,10.34,10.99,4.22,0,7.48-1.81,8.76-5.29l11.7.77c-1.79,8.46-9.39,13.97-20.68,13.97-14.06,0-22.63-9.03-22.63-23.49h0Zm31.66-4.82c-.03-5.44-3.83-9.36-9.32-9.36s-9.57,4.15-9.84,9.36h19.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m264.56,42.28l8.59-15.95h12.98l-13.22,22.81,13.58,22.81h-12.92l-9-15.78-8.85,15.78h-13.07l13.54-22.81-13.07-22.81h13.07l8.37,15.95Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m330.09,32.62c-3.41-4.6-8.38-6.88-13.81-6.88-7.63,0-11.29,4.54-12.99,8.26h-.57v-7.66h-12.47v58.75c4.62.36,8.87,1.54,12.65,3.43v-23.87h.39c1.75,3.81,5.58,8.05,12.95,8.05,5.52,0,10.38-2.31,13.73-6.75,2.98-3.95,4.77-9.57,4.77-16.74s-1.77-12.72-4.67-16.59h.01Zm-17.85,30.01c-6.1,0-9.59-5.35-9.59-13.49s3.45-13.34,9.59-13.34,9.59,5.44,9.59,13.34-3.38,13.49-9.59,13.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m337.98,49.35c0-14.08,8.71-23.61,22.13-23.61,12.06,0,21.45,7.66,21.45,23.17v3.47h-31.07v.03c0,6.8,4.01,10.99,10.34,10.99,4.22,0,7.48-1.81,8.76-5.29l11.7.77c-1.79,8.46-9.39,13.97-20.68,13.97-14.06,0-22.63-9.03-22.63-23.49h0Zm31.66-4.82c-.03-5.44-3.83-9.36-9.32-9.36s-9.57,4.15-9.84,9.36h19.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m386.46,26.34h12.27v7.96h.47c1.66-5.65,5.85-8.62,10.96-8.62,1.27,0,2.85.18,3.99.45v11.23c-1.18-.39-3.6-.68-5.35-.68-5.58,0-9.68,3.86-9.68,9.48v25.81h-12.65V26.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m443.87,35.84h-8.59v22.11c0,3.51,1.75,4.45,4.28,4.45,1.18,0,2.52-.3,3.15-.41l1.99,9.41c-1.27.41-3.59,1.07-6.87,1.18-9.18.39-15.26-4.04-15.21-12.97v-23.76h-6.24v-9.5h6.24v-10.93h12.65v10.93h8.59v9.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m196.31,92.39h12.81l7.07,30.66h.41l7.37-30.66h12.56l7.48,30.48h.39l6.96-30.48h12.77l-12.38,45.62h-13.4l-7.84-28.69h-.57l-7.84,28.69h-13.36l-12.42-45.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m264.53,115.39c0-14.15,8.62-23.58,22.45-23.58s22.45,9.45,22.45,23.58-8.62,23.53-22.45,23.53-22.45-9.48-22.45-23.53Zm32.06-.09c0-7.96-3.27-13.84-9.54-13.84s-9.66,5.88-9.66,13.84,3.27,13.81,9.66,13.81,9.54-5.85,9.54-13.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m314.35,92.39h12.27v7.96h.48c1.66-5.65,5.85-8.62,10.96-8.62,1.27,0,2.85.18,3.99.45v11.23c-1.18-.39-3.6-.68-5.35-.68-5.58,0-9.68,3.86-9.68,9.48v25.81h-12.65v-45.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m370.73,112.15l16.92-19.75h-14.53l-14.61,17.32h-.68v-30.1c-4.63-.28-8.89-1.34-12.65-3.05v61.47h12.65v-14.51l3.42-3.88,12.45,18.39h14.83l-17.8-25.87h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m386.76,115.41c0-14.08,8.71-23.61,22.13-23.61,12.06,0,21.45,7.66,21.45,23.17v3.47h-31.07v.03c0,6.8,4.01,10.99,10.34,10.99,4.22,0,7.48-1.81,8.76-5.29l11.7.77c-1.79,8.46-9.39,13.97-20.68,13.97-14.05,0-22.63-9.03-22.63-23.49h0Zm31.66-4.82c-.03-5.44-3.83-9.36-9.32-9.36s-9.57,4.15-9.84,9.36h19.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m435.25,92.39h12.27v7.96h.48c1.66-5.65,5.85-8.62,10.96-8.62,1.27,0,2.85.18,3.99.45v11.23c-1.18-.39-3.6-.68-5.35-.68-5.58,0-9.68,3.86-9.68,9.48v25.81h-12.65v-45.63Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/Logo.41e9613db07285b7aef3837cd2e245d3.svg";
export { ForwardRef as ReactComponent };